import devRuntimeCode from "../devRuntimeCode";

export interface JsxSourceFeature {
  resolveId(id: string, importer?: string): string | null;
  load(id: string): string | null;
}

export function createJsxTaggerFeature(): JsxSourceFeature {
  return {
    resolveId(id: string, importer?: string): string | null {
      if (id === "react/jsx-dev-runtime" && !importer?.includes("\0jsx-source")) {
        return "\0jsx-source/jsx-dev-runtime";
      }
      return null;
    },
    load(id: string): string | null {
      if (id === "\0jsx-source/jsx-dev-runtime") {
        return devRuntimeCode;
      }
      return null;
    },
  };
}
